export const search = (data, searchInput) => {
  return data.filter((data) => data.id.toString().includes(searchInput) || data.name.includes(searchInput))
};
